import axiosCreate from '@/utils/AxiosUtil'

/* 创建实例 */
export default axiosCreate({
    baseURL: process.env.VUE_APP_REQUEST_URL
})
